import type en from '../en/rental'
import type { Translation } from '../types'

/** Rental */
const rental: Translation<typeof en> = {
  "rental.title": "Location",
  "rental.subtitle": "Stock, planification, événements et achats",
  "rental.sections": "Sections de la location",
  "rental.tab.planning": "Planning",
  "rental.tab.events": "Événements",
  "rental.tab.customers": "Clients",
  "rental.tab.stock": "Stock",
  "rental.tab.suppliers": "Fournisseurs",
  "rental.tab.purchasing": "Achats",
  "rental.search": "Rechercher",
  "rental.notes": "Remarques",
  "rental.details": "Coordonnées",
  "rental.saveFailed": "L’enregistrement a échoué",
  "rental.amountInvalid": "Un montant n’est pas un nombre, comme 12,50",
  "rental.percentInvalid": "Un pourcentage est un nombre de 0 à 100",
  "rental.stock.sections": "Sections du stock",
  "rental.stock.articles": "Articles",
  "rental.stock.items": "Inventaire",
  "rental.stock.warehouses": "Entrepôts",
  "rental.stock.transfers": "Transferts",
  "rental.stock.categories": "Catégories",
  "rental.article.add": "Ajouter un article",
  "rental.article.edit": "Modifier l’article",
  "rental.article.save": "Enregistrer l’article",
  "rental.article.saved": "Article enregistré",
  "rental.article.deleted": "Article supprimé",
  "rental.article.deleteConfirm": "Supprimer l’article {name} ? Un article avec des exemplaires, du stock ou des lignes ne peut pas être supprimé : désactivez-le plutôt.",
  "rental.article.empty": "Aucun article pour l’instant",
  "rental.article.sku": "Référence",
  "rental.article.name": "Nom",
  "rental.article.description": "Description",
  "rental.article.category": "Catégorie",
  "rental.article.allCategories": "Toutes les catégories",
  "rental.article.showInactive": "Afficher les inactifs",
  "rental.article.inactive": "Inactif",
  "rental.article.active": "Actif (peut figurer sur des événements)",
  "rental.article.perItem": "À l’unité (numéro de série)",
  "rental.article.bulk": "Quantité (vrac)",
  "rental.article.dayPrice": "Prix par jour",
  "rental.article.weekendPrice": "Prix week-end",
  "rental.article.weekPrice": "Prix semaine",
  "rental.article.fromDayPrice": "Vide : à partir du prix par jour",
  "rental.article.vatRate": "TVA (%)",
  "rental.article.vatDefault": "Vide : le taux par défaut de l’entreprise",
  "rental.article.vatDefaultShort": "par défaut",
  "rental.article.purchasePrice": "Prix d’achat",
  "rental.article.externalCode": "Code dans le logiciel de facturation",
  "rental.article.prices": "Prix hors TVA",
  "rental.article.stock": "Stock",
  "rental.article.noStock": "Rien en stock",
  "rental.item.add": "Ajouter un exemplaire",
  "rental.item.save": "Enregistrer l’exemplaire",
  "rental.item.saved": "Exemplaire enregistré",
  "rental.item.empty": "Aucun exemplaire",
  "rental.item.serial": "Numéro de série",
  "rental.item.mac": "Adresse MAC",
  "rental.item.tag": "Étiquette",
  "rental.item.tagHint": "L’étiquette NFC ou le code QR (facultatif pour l’instant)",
  "rental.item.article": "Article",
  "rental.item.warehouse": "Entrepôt",
  "rental.item.status": "Statut",
  "rental.item.statusOf": "Statut de {name}",
  "rental.item.historyOf": "Historique de {name}",
  "rental.item.allArticles": "Tous les articles",
  "rental.item.allWarehouses": "Tous les entrepôts",
  "rental.item.allStatuses": "Tous les statuts",
  "rental.bulk.title": "Quantité par entrepôt",
  "rental.bulk.count": "Compter",
  "rental.bulk.countOf": "Compter {name}",
  "rental.bulk.counted": "Compté",
  "rental.bulk.note": "Pourquoi (facultatif)",
  "rental.bulk.save": "Enregistrer le comptage",
  "rental.bulk.saved": "Comptage enregistré",
  "rental.bulk.quantity": "Quantité",
  "rental.bulk.packed": "Dont en valises",
  "rental.warehouse.add": "Ajouter un entrepôt",
  "rental.warehouse.edit": "Modifier l’entrepôt",
  "rental.warehouse.editOf": "Modifier {name}",
  "rental.warehouse.save": "Enregistrer l’entrepôt",
  "rental.warehouse.saved": "Entrepôt enregistré",
  "rental.warehouse.deleted": "Entrepôt supprimé",
  "rental.warehouse.deleteOf": "Supprimer {name}",
  "rental.warehouse.deleteConfirm": "Supprimer l’entrepôt {name} ? Seul un entrepôt vide et sans événements peut être supprimé.",
  "rental.warehouse.empty": "Aucun entrepôt pour l’instant : ajoutez le premier",
  "rental.warehouse.name": "Nom",
  "rental.warehouse.address": "Adresse",
  "rental.warehouse.default": "Entrepôt principal",
  "rental.warehouse.makeDefault": "En faire l’entrepôt principal",
  "rental.warehouse.makeDefaultOf": "Faire de {name} l’entrepôt principal",
  "rental.transfer.add": "Nouveau transfert",
  "rental.transfer.save": "Transférer",
  "rental.transfer.done": "Transféré",
  "rental.transfer.empty": "Aucun transfert pour l’instant",
  "rental.transfer.from": "De",
  "rental.transfer.to": "Vers",
  "rental.transfer.when": "Quand",
  "rental.transfer.fromTo": "De → vers",
  "rental.transfer.what": "Quoi",
  "rental.transfer.by": "Par",
  "rental.transfer.bulk": "Quantités",
  "rental.transfer.noItems": "Aucun exemplaire libre ni unité dans cet entrepôt (le contenu d’une unité la suit)",
  "rental.transfer.summary": "Exemplaires et unités : {items} · vrac : {bulk}",
  "rental.category.add": "Ajouter une catégorie",
  "rental.category.name": "Nom de la catégorie",
  "rental.category.saved": "Catégorie enregistrée",
  "rental.category.deleted": "Catégorie supprimée",
  "rental.category.renameOf": "Renommer {name}",
  "rental.category.deleteOf": "Supprimer {name}",
  "rental.category.deleteConfirm": "Supprimer la catégorie {name} ? Ses articles restent, sans catégorie.",
  "rental.category.empty": "Aucune catégorie pour l’instant",
  "rental.history.title": "Historique",
  "rental.history.empty": "Rien ne s’est encore passé",
  "rental.history.quantity": { one: "{count} pièce", other: "{count} pièces" },
  "rental.history.item.status": "Statut modifié",
  "rental.history.bulk.count": "Compté",
  "rental.history.transfer": "Transfert",
  "rental.history.receipt": "Réceptionné",
  "rental.history.subrental.return": "Rendu au fournisseur",
  "rental.status.IN_STOCK": "En stock",
  "rental.status.AT_EVENT": "Sur un événement",
  "rental.status.IN_REPAIR": "En réparation",
  "rental.status.LOST": "Perdu",
  "rental.status.RETIRED": "Réformé",
  "rental.status.RETURNED": "Rendu au fournisseur",
  "rental.status.REQUESTED": "Demandé",
  "rental.status.RESERVED": "Réservé",
  "rental.status.CONFIRMED": "Confirmé",
  "rental.status.CLOSED": "Clôturé",
  "rental.status.CANCELLED": "Annulé",
  "rental.status.DRAFT": "Brouillon",
  "rental.status.AWAITING_APPROVAL": "En attente d’approbation",
  "rental.status.SENT": "Envoyé",
  "rental.status.PARTLY_RECEIVED": "Reçu en partie",
  "rental.status.RECEIVED": "Reçu",
  "rental.customer.add": "Ajouter un client",
  "rental.customer.edit": "Modifier le client",
  "rental.customer.save": "Enregistrer le client",
  "rental.customer.saved": "Client enregistré",
  "rental.customer.deleted": "Client supprimé",
  "rental.customer.deleteConfirm": "Supprimer le client {name} ? Un client avec des événements ne peut pas être supprimé.",
  "rental.customer.empty": "Aucun client pour l’instant",
  "rental.customer.name": "Nom",
  "rental.customer.contact": "Personne de contact",
  "rental.customer.email": "E-mail",
  "rental.customer.phone": "Téléphone",
  "rental.customer.address": "Adresse",
  "rental.customer.vatNumber": "N° de TVA",
  "rental.customer.externalRef": "Code dans le logiciel de facturation",
  "rental.customer.noEvents": "Aucun événement pour l’instant",
  "rental.supplier.add": "Ajouter un fournisseur",
  "rental.supplier.edit": "Modifier le fournisseur",
  "rental.supplier.save": "Enregistrer le fournisseur",
  "rental.supplier.saved": "Fournisseur enregistré",
  "rental.supplier.deleted": "Fournisseur supprimé",
  "rental.supplier.deleteConfirm": "Supprimer le fournisseur {name} ? Un fournisseur avec des commandes ne peut pas être supprimé.",
  "rental.supplier.empty": "Aucun fournisseur pour l’instant",
  "rental.supplier.name": "Nom",
  "rental.supplier.contact": "Personne de contact",
  "rental.supplier.email": "E-mail",
  "rental.supplier.phone": "Téléphone",
  "rental.supplier.address": "Adresse",
  "rental.supplier.vatNumber": "N° de TVA",
  "rental.supplier.language": "Langue",
  "rental.supplier.languageHint": "Ses lettres de commande et e-mails sont dans cette langue",
  "rental.supplier.orders": "Commandes et demandes",
  "rental.supplier.noOrders": "Aucune commande ni demande pour l’instant",
  "rental.settings.prices": "Prix",
  "rental.settings.method": "Calcul des prix",
  "rental.settings.method.STAFFEL": "Un prix par jour avec un barème",
  "rental.settings.method.STAFFEL.hint": "Le prix par jour multiplié par le facteur du nombre de jours",
  "rental.settings.method.FIXED": "Prix fixes par jour, week-end et semaine",
  "rental.settings.method.FIXED.hint": "Dans un même week-end (vendredi 12:00 à lundi 12:00) le prix week-end ; sinon semaines et jours, les jours jamais plus qu’une semaine",
  "rental.settings.staffel": "Le barème",
  "rental.settings.from": "À partir de",
  "rental.settings.days": "Jours",
  "rental.settings.daysTimes": "jours :",
  "rental.settings.factor": "Facteur",
  "rental.settings.dayPrice": "× le prix par jour",
  "rental.settings.addRow": "Ajouter une ligne",
  "rental.settings.removeRow": "Supprimer cette ligne",
  "rental.settings.extraDay": "Chaque jour après la dernière ligne ajoute (× le prix par jour)",
  "rental.settings.staffelInvalid": "Chaque ligne du barème demande des jours entiers et un facteur comme 1,5",
  "rental.settings.vat": "Taux de TVA par défaut (%)",
  "rental.settings.currency": "Devise",
  "rental.settings.fourEyes": "Quelqu’un d’autre doit approuver",
  "rental.settings.fourEyesHint": "Qui crée ou soumet un bon de commande ou une demande de sous-location ne peut pas l’approuver",
  "rental.settings.letters": "Sur les lettres aux fournisseurs",
  "rental.settings.lettersHint": "Le logo de l’entreprise figure en tête s’il existe",
  "rental.settings.letterName": "Raison sociale",
  "rental.settings.letterAddress": "Adresse",
  "rental.settings.letterVat": "N° de TVA",
  "rental.settings.letterCoc": "N° d’immatriculation",
  "rental.settings.letterEmail": "E-mail",
  "rental.settings.letterPhone": "Téléphone",
  "rental.settings.save": "Enregistrer les paramètres de location",
  "rental.settings.saved": "Paramètres de location enregistrés",
  "rental.event.add": "Nouvel événement",
  "rental.event.edit": "Modifier l’événement",
  "rental.event.save": "Enregistrer l’événement",
  "rental.event.saved": "Événement enregistré",
  "rental.event.empty": "Aucun événement pour l’instant",
  "rental.event.needed": "Choisissez le client et la période de location",
  "rental.event.name": "Événement",
  "rental.event.customer": "Client",
  "rental.event.rentalStart": "Début de la location",
  "rental.event.rentalEnd": "Fin de la location",
  "rental.event.rentalPeriod": "Période de location",
  "rental.event.materialPeriod": "Départ et retour du matériel",
  "rental.event.materialOut": "Départ du matériel",
  "rental.event.materialBack": "Retour du matériel",
  "rental.event.materialApart": "Le matériel part plus tôt ou revient plus tard que la location",
  "rental.event.warehouse": "Entrepôt principal",
  "rental.event.homeWarehouse": "L’entrepôt principal de l’entreprise",
  "rental.event.site": "Site",
  "rental.event.externalRef": "Numéro de devis",
  "rental.event.total": "Total",
  "rental.event.short": "Manque",
  "rental.event.reserve": "Réserver",
  "rental.event.confirm": "Confirmer",
  "rental.event.close": "Clôturer",
  "rental.event.cancel": "Annuler l’événement",
  "rental.event.reopen": "Rouvrir",
  "rental.event.cancelConfirm": "Annuler l’événement {name} ? Il ne retient alors plus de matériel.",
  "rental.event.statusSaved": "Désormais : {status}",
  "rental.line.title": "Lignes",
  "rental.line.empty": "Aucune ligne pour l’instant : ajoutez un article ci-dessous",
  "rental.line.add": "Ajouter la ligne",
  "rental.line.save": "Enregistrer la ligne",
  "rental.line.saved": "Ligne enregistrée",
  "rental.line.deleted": "Ligne supprimée",
  "rental.line.editOf": "Modifier la ligne de {name}",
  "rental.line.deleteOf": "Supprimer la ligne de {name}",
  "rental.line.deleteConfirm": "Supprimer la ligne de {name} ?",
  "rental.line.quantity": "Quantité",
  "rental.line.unitPrice": "Prix unitaire",
  "rental.line.calculated": "calculé {price}",
  "rental.line.customPrice": "Prix unitaire libre",
  "rental.line.customHint": "Vide : le prix calculé {price}",
  "rental.line.availability": "Libre et manquant",
  "rental.line.shortBy": "Manque {count}",
  "rental.line.free": "Libre : {free} (si les devis en cours tombent : {fall})",
  "rental.line.subrented": "{count} sous-loué(s)",
  "rental.line.expected": "{count} attendu(s)",
  "rental.line.requested": "{count} demandé(s), pas encore confirmé(s)",
  "rental.line.transferFrom": "Transférer depuis {name}",
  "rental.discount.title": "Remise",
  "rental.discount.type": "Type",
  "rental.discount.none": "Aucune",
  "rental.discount.percent": "Un pourcentage",
  "rental.discount.amount": "Un montant",
  "rental.discount.value": "Montant",
  "rental.discount.save": "Enregistrer la remise",
  "rental.discount.saved": "Remise enregistrée",
  "rental.totals.title": "Totaux",
  "rental.totals.subtotal": "Sous-total",
  "rental.totals.discount": "Remise",
  "rental.totals.vat": "TVA {rate}",
  "rental.totals.total": "Total",
  "rental.planning.table": "Planning",
  "rental.planning.span": "Période",
  "rental.planning.day": "Jour",
  "rental.planning.week": "Semaine",
  "rental.planning.month": "Mois",
  "rental.planning.date": "Date",
  "rental.planning.previous": "Précédent",
  "rental.planning.next": "Suivant",
  "rental.planning.today": "Aujourd’hui",
  "rental.planning.cell": "{article}, {day} : {free} libre(s), {held} retenu(s)",
  "rental.planning.cellShort": "— {count} manquant(s)",
  "rental.planning.shortEvents": "Événements en manque",
  "rental.planning.noneShort": "Rien ne manque sur cette période",
  "rental.planning.owned": "Possédé",
  "rental.planning.subrented": "Sous-loué",
  "rental.planning.expected": "Attendu",
  "rental.planning.from": "À partir de",
  "rental.planning.held": "Retenu",
  "rental.planning.free": "Libre",
  "rental.order.purchaseOrders": "Bons de commande",
  "rental.order.subRentals": "Sous-locations",
  "rental.order.purchaseOrder": "Bon de commande",
  "rental.order.subRental": "Sous-location",
  "rental.order.newPurchase": "Nouveau bon de commande",
  "rental.order.newSubRental": "Nouvelle sous-location",
  "rental.order.savePurchase": "Enregistrer le bon de commande",
  "rental.order.saveSubRental": "Enregistrer la sous-location",
  "rental.order.purchaseSaved": "Bon de commande enregistré",
  "rental.order.subRentalSaved": "Sous-location enregistrée",
  "rental.order.edit": "Modifier {number}",
  "rental.order.editShort": "Modifier",
  "rental.order.deleted": "Supprimé",
  "rental.order.deleteConfirm": "Supprimer le brouillon {number} ?",
  "rental.order.empty": "Rien pour l’instant",
  "rental.order.number": "Numéro",
  "rental.order.supplier": "Fournisseur",
  "rental.order.warehouse": "Entrepôt de réception",
  "rental.order.expected": "Livraison prévue",
  "rental.order.window": "Période de location",
  "rental.order.from": "Du",
  "rental.order.to": "Au",
  "rental.order.forEvent": "Pour l’événement",
  "rental.order.notes": "Remarques pour le fournisseur",
  "rental.order.supplierCode": "Référence du fournisseur",
  "rental.order.unitPrice": "Prix unitaire",
  "rental.order.unitCost": "Coût unitaire",
  "rental.order.received": "Reçu jusqu’ici",
  "rental.order.items": "Exemplaires enregistrés",
  "rental.order.madeBy": "Créé par",
  "rental.order.askedBy": "Approbation demandée par",
  "rental.order.approvedBy": "Approuvé par",
  "rental.order.sentTo": "Envoyé à",
  "rental.order.askApproval": "Demander l’approbation",
  "rental.order.approve": "Approuver",
  "rental.order.sendAgain": "Renvoyer",
  "rental.order.recordConfirmation": "Enregistrer la confirmation",
  "rental.order.registerItems": "Enregistrer les exemplaires",
  "rental.order.saveItems": "Enregistrer les exemplaires",
  "rental.order.itemsSaved": "Exemplaires enregistrés",
  "rental.order.allRegistered": "Tous enregistrés",
  "rental.order.close": "Clôturer la sous-location",
  "rental.order.closeConfirm": "Clôturer ? Ses exemplaires enregistrés retournent au fournisseur.",
  "rental.order.receive": "Réceptionner",
  "rental.order.receiveLine": "{name} : {received} reçu(s) sur {quantity}, maintenant",
  "rental.order.serialOf": "Numéro de série {n}",
  "rental.order.saveReceipt": "Enregistrer la réception",
  "rental.order.receiptSaved": "Réception enregistrée",
  "rental.order.newExpected": "Nouvelle date prévue",
  "rental.order.saveExpected": "Enregistrer la date",
  "rental.order.expectedSaved": "Date prévue enregistrée",
  "rental.order.cancelOrder": "Annuler la commande",
  "rental.order.cancelRequest": "Annuler la demande",
  "rental.order.cancelConfirm": "Annuler {number} ?",
  "rental.order.pdf": "Télécharger le PDF",
  "rental.order.waiting": "En attente d’une personne autorisée à approuver",
  "rental.order.someoneElse": "Quelqu’un d’autre doit approuver ceci",
  "rental.order.notSent": "Approuvé, non envoyé",
  "rental.order.notSentReason": "Approuvé, mais l’e-mail au fournisseur n’est pas parti : {reason}",
  "rental.order.done.request-approval": "Soumis à approbation",
  "rental.order.done.approve": "Approuvé et envoyé",
  "rental.order.done.send": "Envoyé au fournisseur",
  "rental.order.done.cancel": "Annulé",
  "rental.order.done.confirm": "Confirmation enregistrée",
  "rental.order.done.close": "Clôturée : ses exemplaires sont rendus",
  "rental.order.byHandHint": "Téléchargez le PDF et envoyez-le vous-même au fournisseur, puis marquez la commande comme envoyée.",
  "rental.order.markSent": "Marquer comme envoyé",
  "rental.order.markSentConfirm": "Marquer {number} comme envoyé ? Faites-le une fois la lettre chez le fournisseur.",
  "rental.order.done.mark-sent": "Marqué comme envoyé",
  "rental.order.sentByHand": "À la main, marqué par {name} · {when}",
  "rental.article.kind": "Type",
  "rental.article.kit": "Kit",
  "rental.article.container": "Valise",
  "rental.article.kindHint.ITEM": "Chaque exemplaire a son numéro de série ou son étiquette",
  "rental.article.kindHint.BULK": "Compté, pas un par un (câbles, adaptateurs)",
  "rental.article.kindHint.KIT": "Composé d’autres articles à la location (sa recette) ; pas de stock propre",
  "rental.article.kindHint.CONTAINER": "Une valise ou un ensemble dont chaque unité contient d’autres articles (chaque unité a son code)",
  "rental.kit.noStock": "Un kit n’a pas de stock propre : il est composé de ses éléments à la location.",
  "rental.item.kind": "Type",
  "rental.item.allKinds": "Exemplaires et unités",
  "rental.item.kindPlain": "Exemplaires",
  "rental.item.kindPieces": "Unités de valises",
  "rental.item.piece": "Dans l’unité",
  "rental.item.device": "Appareil",
  "rental.recipe.title": "Recette",
  "rental.recipe.kitHint": "Ce que contient un kit. Une ligne d’événement de N kits réserve N fois chaque élément.",
  "rental.recipe.containerHint": "Ce que chaque unité doit contenir. Une unité qui contient autre chose est signalée incomplète.",
  "rental.recipe.empty": "Aucun élément pour l’instant",
  "rental.recipe.part": "Élément",
  "rental.recipe.quantity": "Quantité",
  "rental.recipe.add": "Ajouter un élément",
  "rental.recipe.removeOf": "Retirer {name} de la recette",
  "rental.recipe.saved": "Recette enregistrée",
  "rental.piece.title": "Unités",
  "rental.piece.add": "Ajouter une unité",
  "rental.piece.edit": "Modifier l’unité",
  "rental.piece.save": "Enregistrer l’unité",
  "rental.piece.saved": "Unité enregistrée",
  "rental.piece.code": "Code",
  "rental.piece.contents": "Contenu",
  "rental.piece.empty": "Aucune unité pour l’instant",
  "rental.piece.complete": "Complète",
  "rental.piece.incomplete": "Incomplète",
  "rental.piece.notRecipe": "Pas conforme à la recette :",
  "rental.piece.missing": "manque : {count} × {name}",
  "rental.piece.extra": "en trop : {count} × {name}",
  "rental.piece.nothing": "Vide",
  "rental.piece.addItem": "Ajouter un exemplaire",
  "rental.piece.addBulk": "Ajouter du vrac",
  "rental.piece.addDevice": "Ajouter un appareil",
  "rental.piece.addOne": "Ajouter",
  "rental.piece.item": "Exemplaire",
  "rental.piece.noItems": "Aucun exemplaire libre en stock dans cet entrepôt",
  "rental.piece.takeOut": "Retirer",
  "rental.piece.takeOutOf": "Retirer {name}",
  "rental.piece.contentsSaved": "Contenu enregistré",
  "rental.device.search": "Numéro de série, MAC ou nom",
  "rental.device.searchHint": "Parmi les appareils du tableau de bord sur les sites que vous pouvez voir",
  "rental.device.none": "Aucun appareil trouvé",
  "rental.device.pick": "Choisir",
  "rental.device.pickOf": "Choisir {name}",
  "rental.device.inInventory": "Déjà dans l’inventaire",
  "rental.device.takenByOther": "Lié à un autre exemplaire",
  "rental.device.other": "Un autre appareil",
  "rental.device.article": "Article de son exemplaire",
  "rental.device.articleHint": "Pas encore dans l’inventaire : il devient un exemplaire de cet article",
  "rental.device.hidden": "Sur un site que vous ne voyez pas",
  "rental.device.tie": "Lier à un appareil",
  "rental.device.tieOf": "Lier {name} à un appareil",
  "rental.device.tied": "Appareil lié",
  "rental.device.untie": "Délier l’appareil",
  "rental.device.untieOf": "Délier l’appareil de {name}",
  "rental.device.untieConfirm": "Délier l’appareil de {name} ? L’exemplaire reste dans l’inventaire.",
  "rental.device.untied": "Appareil délié",
  "rental.line.incomplete": { one: "{count} des unités libres est incomplète", other: "{count} des unités libres sont incomplètes" },
  "rental.line.perKit": "{count} par kit",
  "rental.planning.kitDay": "Un kit n’a pas de stock propre : voici les kits que ses éléments permettent au moment le plus bas de la journée.",
  "rental.order.expectedHint": "Compte comme attendu dès le début de ce jour",
  "rental.recipe.quantityOf": "Quantité de {name}",
  "rental.item.kindItem": "Exemplaire",
  "rental.device.lastSeen": "Vu {when}",
  "rental.history.item.piece.in": "Mis dans une unité",
  "rental.history.item.piece.out": "Retiré d’une unité",
  "rental.history.bulk.piece": "Vrac dans une unité",
  "rental.history.device.tie": "Lié à un appareil",
  "rental.history.device.untie": "Appareil délié",
  "rental.event.comment": "Commentaire",
  "rental.event.commentPlaceholder": "Une note pour tous sur cet événement : le client, les planificateurs, les techniciens",
  "rental.event.commentBy": "Dernière modification par {name}, {when}",
  "rental.event.saveComment": "Enregistrer le commentaire",
  "rental.event.commentSaved": "Commentaire enregistré",
  "rental.load.title": "Chargement",
  "rental.load.scan": "Scannez ou tapez un code",
  "rental.load.scanHint": "Une étiquette, un code de pièce, un numéro de série ou une MAC : un scanner le tape et appuie sur Entrée",
  "rental.load.mode": "Ce que fait un scan",
  "rental.load.modeLoad": "Charger",
  "rental.load.modeReturn": "Retour : {status}",
  "rental.load.loaded": "Chargé : {name}",
  "rental.load.returned": "Rendu : {name}",
  "rental.load.failed": "Non chargé",
  "rental.load.returnFailed": "Non rendu",
  "rental.load.count": "{out} sur {quantity} sortis",
  "rental.load.byHand": "Ajouter à la main",
  "rental.load.byHandOf": "Ajouter à la main : {name}",
  "rental.load.empty": "Rien de chargé pour l’instant",
  "rental.load.out": "Sorti",
  "rental.load.when": "{when} · {who}",
  "rental.load.return": "Rendre",
  "rental.load.returnOf": "Rendre {name}",
  "rental.load.part": "Pièce du kit",
  "rental.load.choose": "Article ou pièce",
  "rental.load.none": "Rien de cela n’est libre dans l’entrepôt de l’événement",
  "rental.load.quantity": "Quantité",
  "rental.load.load": "Charger",
  "rental.load.missing": "Manquant dans la pièce (perdu)",
  "rental.load.cameBack": "Revenu",
  "rental.load.cameBackHint": "Sur {count} sortis ; le reste est noté perdu",
  "rental.settings.archiveDays": "Garder un site d’événement après sa clôture (jours)",
  "rental.settings.archiveDaysHint": "Archivé, puis supprimé après ce nombre de jours (1–3650)",
  "rental.load.cameBackOf": "{back} sur {out} revenus",
  "rental.bulk.out": "Dont aux événements",
  "rental.bulk.countedHint": "Ce qui est dans cet entrepôt maintenant, y compris dans les caisses ; ce qui est sorti pour des événements s’y ajoute",
  "rental.people.title": "Personnes du client",
  "rental.people.hint": "Les personnes de ce client qui se connectent pour voir leurs événements : les dates, le matériel sur place et son état, et le commentaire",
  "rental.people.email": "Adresse e-mail",
  "rental.people.name": "Nom (facultatif)",
  "rental.people.only": "Uniquement pendant l’événement",
  "rental.people.onlyHint": "La connexion n’est possible que de la sortie au retour du matériel de l’un de leurs événements",
  "rental.people.onlyFixed": "Vous l’avez vous-même : les personnes que vous invitez l’ont aussi",
  "rental.people.main": "Contact principal",
  "rental.people.mainHint": "Peut inviter et retirer d’autres personnes de ce client",
  "rental.people.invite": "Inviter",
  "rental.people.invited": "Invitation envoyée à {email}",
  "rental.people.notSent": "{email} a été ajouté, mais l’e-mail n’a pas pu être envoyé",
  "rental.people.none": "Personne de ce client n’a encore de compte",
  "rental.people.pending": "Invité — pas encore de mot de passe",
  "rental.people.invitedBy": "Invité par {name}, {when}",
  "rental.people.makeMain": "Désigner comme contact principal",
  "rental.people.remove": "Retirer",
  "rental.people.removeOf": "Retirer {name}",
  "rental.people.removeConfirm": "Retirer l’accès de {name} ? Cette personne ne pourra plus se connecter aux événements de ce client.",
  "rental.people.removed": "Accès retiré",
  "rental.people.saved": "Enregistré",
  "rental.people.failed": "Non enregistré",
  "rental.portal.myEvents": "Mes événements",
  "rental.portal.people": "Personnes",
  "rental.portal.nav": "Vue client",
  "rental.portal.elsewhere": "Changer",
  "rental.portal.noEvents": "Aucun événement à afficher pour l’instant",
  "rental.portal.noSite": "Cet événement n’a plus de site",
  "rental.portal.viewAsClient": "Voir comme le client",
  "rental.portal.previewBar": "Vous voyez ce que voient les personnes de {customer} — lecture seule",
  "rental.portal.previewBarNobody": "Ce que verront les personnes de {customer} une fois invitées — lecture seule",
  "rental.portal.backToEvent": "Retour à l’événement",
  "rental.portal.hiddenRequested": "Le client ne voit pas cet événement : il est demandé",
  "rental.portal.hiddenCancelled": "Le client ne voit pas cet événement : il est annulé",
  "rental.portal.account": "Mon compte",
  "rental.category.nameNeeded": "Saisissez d’abord un nom pour la catégorie",
  "rental.portal.devBanner": "Ce produit est encore en plein développement et reste ouvert à vos retours",
  "rental.item.addHow": "Comment ajouter",
  "rental.item.fromDashboard": "Depuis le tableau de bord",
  "rental.item.byHand": "À la main",
  "rental.item.brand": "Marque",
  "rental.item.allBrands": "Toutes les marques",
  "rental.item.browseQ": "Nom, numéro de série ou MAC",
  "rental.item.browseHint": "Une partie suffit, comme RX",
  "rental.item.found": { one: "{count} appareil trouvé", other: "{count} appareils trouvés" },
  "rental.item.tooMany": "Les {shown} premiers sur {total} affichés : affinez le filtre pour les autres",
  "rental.item.selectAll": "Tout sélectionner ({count})",
  "rental.item.selectNone": "Effacer la sélection",
  "rental.item.addCount": { one: "Ajouter {count} article", other: "Ajouter {count} articles" },
  "rental.item.addedMany": { one: "{count} article ajouté", other: "{count} articles ajoutés" },
  "rental.item.chooseDevices": "Cochez d’abord les appareils à ajouter",
  "rental.item.remove": "Retirer",
  "rental.item.removeOf": "Retirer {name}",
  "rental.item.removeConfirm": "Retirer {name} ? Un article jamais sorti pour un événement est supprimé ; un article déjà sorti est mis hors service et garde son historique.",
  "rental.item.deleted": "Article supprimé",
  "rental.item.retiredDone": "Article mis hors service : son historique est conservé",
  "rental.item.showRetired": "Afficher les articles hors service",
  "rental.history.item.delete": "Article supprimé",
  "rental.event.remove": "Supprimer l’événement",
  "rental.event.removeConfirm": "Supprimer l’événement {name} ? Ses lignes, ce qui est sorti et revenu, son site, les commentaires sur les appareils et les graphiques sont supprimés définitivement. Les sous-locations pour lui restent, sans l’événement.",
  "rental.event.removed": "Événement supprimé",
  "rental.event.removeFailed": "L’événement n’a pas été supprimé",
  "rental.event.removableFrom": "Peut être supprimé à partir du {date}",
  "rental.portal.push": "Notification push quand un équipement de mon événement passe hors ligne",
  "rental.portal.pushNeedsApp": "Nécessite l'application Velanox",
  "rental.portal.pushRefused": "Les notifications push n'ont pas été autorisées sur ce téléphone",
  "rental.scan.unsentConfirm": {"one": "1 scan n'a pas été envoyé. Vous déconnecter quand même ? Il sera perdu.", "other": "{count} scans n'ont pas été envoyés. Vous déconnecter quand même ? Ils seront perdus."},
  "rental.scan.summaryTitle": "Scans envoyés",
  "rental.scan.summary": "{loaded} chargés, {returned} retournés, {refused} refusés",
  "rental.scan.unknownCount": {"one": "1 code ne correspondait à rien", "other": "{count} codes ne correspondaient à rien"},
  "rental.scan.dismiss": "Fermer",
  "rental.scan.open": "Scanner",
  "rental.scan.nfc": "NFC",
  "rental.scan.title": "Scan pour {name}",
  "rental.scan.torch": "Lampe",
  "rental.scan.done": "Terminé",
  "rental.scan.sending": "Envoi…",
  "rental.scan.waiting": "En attente de la connexion",
  "rental.scan.unknown": "ne correspond à rien",
  "rental.scan.loadedRow": "{name} · chargé",
  "rental.scan.returnedRow": "{name} · retourné",
  "rental.scan.noCamera": "La caméra n'est pas autorisée pour l'app : autorisez-la dans les réglages du téléphone",
  "rental.scan.hint": "Gardez les codes dans le cadre",
  "rental.scan.hintNfc": "Gardez les codes dans le cadre, ou approchez un tag du téléphone",
  "rental.scan.nfcPrompt": "Approchez un tag du haut de l'iPhone",
  "rental.tag.of": "Tag de {name}",
  "rental.tag.save": "Enregistrer le tag",
  "rental.tag.hold": "Approchez le tag du téléphone",
  "rental.tag.writeFailed": "Le tag n'a pas pu être écrit : tenez-le immobile et réessayez",
  "rental.tag.scanTitle": "Scanner une étiquette",
  "rental.tag.scanHint": "Gardez le code de l'étiquette dans le cadre",
  "rental.tag.none": "Aucun article ne porte ce tag",
  "rental.tag.looking": "Recherche du tag…",
  "rental.scan.sameItem": "même article, déjà compté",
  "rental.scan.unsentConfirmServer": {"one": "1 scan n'a pas été envoyé. Choisir un autre serveur quand même ? Il sera perdu.", "other": "{count} scans n'ont pas été envoyés. Choisir un autre serveur quand même ? Ils seront perdus."},
  "rental.people.clientExport": "Les clients peuvent exporter",
  "rental.people.clientExportHint": "Les personnes du client peuvent télécharger cet événement depuis leur page : ses appareils avec leurs notes, ses graphiques et la liste des personnes",
  "rental.people.exportOn": "Les clients peuvent exporter cet événement",
  "rental.people.exportOff": "Les clients ne peuvent plus exporter cet événement",
  "rental.planning.exportNote": "disponible par jour ; un nombre négatif est le manque",
  "rental.portal.readOnly": "Lecture seule — ce que cet équipement signale",
  "rental.portal.deviceGone": "Cet appareil n'est plus sur votre événement",
  "rental.portal.noStored": "Rien n'a encore été enregistré pour cet appareil",
  "rental.portal.sinceLoaded": "Depuis {when}, quand il est parti pour cet événement",
  "rental.portal.unnamedLink": "Liaison sans nom",
  "rental.portal.range1h": "1 h",
  "rental.portal.range6h": "6 h",
  "rental.portal.cellular": "Réseau mobile",
  "rental.portal.poe": "PoE",
  "rental.portal.standby": "En attente",
  "rental.portal.unnamedDevice": "Appareil sans nom",
  "rental.pings.title": "Appareils pingués",
  "rental.pings.portalTitle": "Vos appareils",
  "rental.pings.intro": "Pingués à leur adresse IP via les radios MikroTik de votre événement pendant qu'il est en cours.",
  "rental.pings.companyIntro": "Les appareils du client, pingués à leur adresse IP via les radios MikroTik sorties pour l'événement en cours du client — uniquement le réseau de cet événement.",
  "rental.pings.name": "Nom",
  "rental.pings.ip": "Adresse IP",
  "rental.pings.state": "État",
  "rental.pings.rtt": "Temps de réponse",
  "rental.pings.answered": "Dernière réponse",
  "rental.pings.foundThrough": "Trouvé via",
  "rental.pings.status.ONLINE": "En ligne",
  "rental.pings.status.OFFLINE": "Hors ligne",
  "rental.pings.status.NO_ANSWER": "Pas de réponse",
  "rental.pings.status.UNKNOWN": "Non vérifié",
  "rental.pings.add": "Ajouter un appareil",
  "rental.pings.edit": "Modifier",
  "rental.pings.save": "Enregistrer",
  "rental.pings.remove": "Supprimer",
  "rental.pings.removeConfirm": "Retirer {name} des appareils pingués ?",
  "rental.pings.pingNow": "Pinguer manuellement",
  "rental.pings.pingAll": "Tout pinguer",
  "rental.pings.none": "Pas encore d'appareils",
  "rental.pings.mode": "Contrôles par ping",
  "rental.pings.mode.EVERY_30S": "Toutes les 30 secondes",
  "rental.pings.mode.EVERY_MINUTE": "Toutes les minutes",
  "rental.pings.mode.EVERY_5_MINUTES": "Toutes les 5 minutes",
  "rental.pings.mode.ON_OPEN": "Uniquement quand j'ouvre le tableau de bord",
  "rental.pings.mode.OFF": "Désactivé",
  "rental.pings.changedBy": "Modifié par {name}, {when}",
  "rental.pings.onOpenLine": "Vérifié uniquement tant que cette page est ouverte (au plus toutes les 5 minutes)",
  "rental.pings.notOn": "Non vérifié maintenant : aucun événement du client n'est en cours",
  "rental.pings.answering": "{count} sur {total} répondent",
  "rental.pings.failed": "Cela n'a pas fonctionné",
  "rental.portal.pushPings": "Notification quand mes appareils ne répondent plus",
  "rental.pings.notOnClient": "Non vérifié maintenant : aucun de vos événements n'est en cours",
  "rental.pings.appliesNow": "Vérifié maintenant comme {mode} : le réglage le plus fréquent de vos événements en cours",
  "rental.event.openSite": "Ouvrir le site",
}

export default rental
